function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 153.4070129",
    style: {
      enableBackground: "new 0 0 500 153.4070129"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD2D"
    },
    d: "M0,0h153.407196v77.1526337c0,19.7785492-10.5512848,38.0552139-27.6790314,47.9455261 l-49.0245285,28.3088531l-49.0244598-28.3088531C10.5510798,115.2078476,0,96.9311829,0,77.1526337V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#333333"
    },
    d: "M42.1017799,40.607338v23.996109 c3.2813759-3.7054443,9.2474632-6.2132874,16.0689316-6.2132874h7.4130211v27.8952179 c0,7.4214249-2.0164146,13.917305-5.0082703,17.4903412h32.2450714 c-2.9855957-3.5766602-4.9973984-10.0643082-4.9973984-17.476181V58.3901596h7.413353 c6.8214645,0,12.7873917,2.507843,16.0689316,6.2132874V40.607338H42.1017799z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M189.5775146,103.7724991V40.6109543h64.1548004v14.4356842h-45.0245361v9.0250168h22.2867126 c15.79039,0,27.5207367,3.6089249,27.5207367,19.8490677c0,16.2428589-11.7303467,19.8517761-27.5207367,19.8517761H189.5775146z  M208.7077789,78.5073395v10.8267593h22.3763885c6.4976959,0,8.0303955-1.2609482,8.0303955-5.4133759 c0-4.1497192-1.5326996-5.4133835-8.0303955-5.4133835H208.7077789z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M364.4201355,80.3117981v23.460701H345.289856V40.6109543h19.1302795v23.0095863h31.3089905 V40.6109543h19.1302795v63.1615448H395.729126v-23.460701H364.4201355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M445.6813965,79.9503632v23.8221359h-19.1302795V40.6109543h19.1302795v23.5503845h11.4585876 l19.9414673-23.5503845h21.6548767L473.7429199,70.115509v1.1739883L500,103.7724991h-23.7311096l-19.2185669-23.8221359 H445.6813965z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M314.8385315,94.4784393h-29.8673706l-3.338501,9.2940598h-20.0311584l24.9947815-63.1615448 h27.6104126l24.903717,63.1615448h-20.9333801L314.8385315,94.4784393z M309.6955261,80.0427628l-8.842926-24.9037285h-1.6250916 l-9.0223083,24.9037285H309.6955261z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbankLogo);
export default __webpack_public_path__ + "static/media/tbank_logo.f7c58eb1b8647b1763b28685d9b4838e.svg";
export { ForwardRef as ReactComponent };